export default function LoadingCard({className,count=4, ...props}) {

    return (
        <>
            {
                Array(count).fill(0).map((_,i)=>(
                    <div key={i} className={`h-32 rounded-lg bg-gray-200`} />
                ))
            }


        </>

    )
}